import { useMemo } from 'react';
import { MacrosMenu } from '../../../macros/MacrosMenu';
import { jsx as _jsx } from "react/jsx-runtime";
export const useMacrosConfig = ({
  handleSelectMacro,
  enableMacros,
  macrosMenuConfig
}) => {
  const macrosConfig = useMemo(() => {
    if (!enableMacros || !macrosMenuConfig) {
      return {};
    }
    return {
      MACROS: {
        renderMacrosMenu: insertMacroText => /*#__PURE__*/_jsx(MacrosMenu, {
          onSelectMacro: handleSelectMacro,
          macrosMenuConfig: macrosMenuConfig,
          insertMacroText: insertMacroText
        })
      }
    };
  }, [enableMacros, macrosMenuConfig, handleSelectMacro]);
  return macrosConfig;
};